import $ from 'jquery'
import Popper from 'popper.js'
import 'bootstrap'
import axios from 'axios'
import 'livewire-vue'
import FileInput from './components/ui/FileInput'
import SearchForm from './components/search/SearchForm'
import ProtocolProcesses from './components/protocols/ProtocolProcesses'
import Vue from 'vue'
import PortalVue from 'portal-vue'

Vue.component('file-input', FileInput)
Vue.component('search-form', SearchForm)
Vue.component('protocol-processes', ProtocolProcesses)
Vue.use(PortalVue)

window.Popper = Popper
window.$      = window.jQuery = $
window.axios  = axios
window.Vue    = Vue

// Add guid function to Math class.
Math.guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  }).toUpperCase()
}

/**
 * Show tool tips for aside menu
 */
$(function () {
  $('.aside-menu .stacked-menu .menu-item .menu-link').hover(function (e) {
    const link = $(this)
    
    if (link.innerWidth() < link[0].scrollWidth) {
      link.tooltip({
        title: link.text,
        placement: 'right',
      })
      
      link.tooltip('show')
    }
  })
})
